module.exports = __webpack_public_path__ + "img/product_46.7a52348.svg";